import { UseQueryResult, useQuery } from 'react-query';
import { GetDashboardInfo } from '@pimm/services/lib/delivery-monitor/services';

export const useGetDashboardInfo = (storeId?: string, queryKey?: string): UseQueryResult<Awaited<ReturnType<typeof GetDashboardInfo>>> => {
  const dashboardInfo = useQuery({
    enabled: !!storeId,
    queryKey: [queryKey ?? 'GetDashboardInfo', storeId],
    queryFn: () => GetDashboardInfo(storeId ?? ''),
    staleTime: 0,
    cacheTime: 0,
    refetchOnMount: 'always',
  });
  return dashboardInfo;
};
